import { render } from "./createTemplateProposalComponent.vue?vue&type=template&id=1dbf9db0&scoped=true"
import script from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./createTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./createTemplateProposalComponent.vue?vue&type=style&index=0&id=1dbf9db0&lang=css"
import "./createTemplateProposalComponent.vue?vue&type=style&index=1&id=1dbf9db0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbf9db0"]])

export default __exports__